import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./table.css";
import { cardIndTasas, getIndTasasInstituciones, apidownloadExcelIndicadoresCampo } from "../../service/Service";

const Indicadores = () => {
  const [dataTableTotal, setDataTableTotal] = useState([]);
  const [dataTableTelefonico, setDataTableTelefonico] = useState([]);
  const [dataTableDigital, setDataTableDigital] = useState([]);
  const [dataTablePresencial, setDataTablePresencial] = useState([]);
  const [cardsHomeTotal, setCardsHomeTotal] = useState([]);
  const [cardsHomeTelefonico, setCardsHomeTelefonico] = useState([]);
  const [cardsHomeDigital, setCardsHomeDigital] = useState([]);
  const [cardsHomePresencial, setCardsHomePresencial] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [isloadingtabla, setIsLoadingtabla] = useState(false);

  function TabPane({ children, value, index }) {
      return (
          <div role="tabpanel" hidden={value !== index} style={{ marginTop: '20px' }}>
              {value === index && (
                  <div>{children}</div>
              )}
          </div>
      );
  }

  function Tabs({ children }) {
      const [value, setValue] = useState(0);

      return (
          <div>
              <div>
                  {React.Children.map(children, (child, index) => (
                      <button 
                          onClick={() => setValue(index)}
                          style={{
                              cursor: 'pointer',
                              padding: '10px 20px',
                              margin: '0 5px',
                              border: 'none',
                              borderRadius: '5px',
                              backgroundColor: value === index ? '#4CAF50' : '#E0E0E0',
                              color: value === index ? 'white' : 'black',
                              fontWeight: value === index ? 'bold' : 'normal'
                          }}
                      >
                          {child.props.label}
                      </button>
                  ))}
              </div>
              <div>
                  {React.Children.map(children, (child, index) => {
                      return React.cloneElement(child, { value, index });
                  })}
              </div>
          </div>
      );
  }

  useEffect(() => {
    const fetchcard = async () => {
      setIsLoading(true);

      try {
        const {data, status} = await cardIndTasas();
        const {total, telefonico, digital, presencial} = data.data;
        setCardsHomeTotal(total);
        setCardsHomeTelefonico(telefonico);
        setCardsHomeDigital(digital);
        setCardsHomePresencial(presencial);
      } catch (error) {
      }

      setIsLoading(false);
    };

    const fetchIndTasasIntituciones = async () => {
      setIsLoadingtabla(true);

      try {
        const {data, status} = await getIndTasasInstituciones();
        const {total, telefonico, digital, presencial} = data.data;
        setDataTableTotal(total);
        setDataTableTelefonico(telefonico);
        setDataTableDigital(digital);
        setDataTablePresencial(presencial);
      } catch (error) {
      }

      setIsLoadingtabla(false);
    };

    fetchIndTasasIntituciones();
    fetchcard();
  }, [])

  const downloadExcelIndicadoresCampo = () => {
    apidownloadExcelIndicadoresCampo().then((res) => {
      if ( parseInt(res.status) === 200 ) {
        const {status, msg, data} = res.data;
        if (parseInt(status) === 200 ) {
          console.log(msg);
          window.open(data.url, '_blank');
        } else {
          console.log('OcurriÃ³ un error al descargar los datos.', msg);
        }
      }
    });
  }

  return (
    <div style={{ width: "90%", margin: "0 auto", paddingTop: 10 }}>
      <Tabs>
        <TabPane label="Total">
            {/* Acumulado */}
            <div className="row" style={{ paddingTop: 20 }}>
              <h1 style={{ textAlign: 'center', fontSize: 30 }}>Acumulado</h1>
              <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_logro}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_respuesta}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_cooperacion}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_rechazo}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_contacto}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2" style={{ paddingRight: 50 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.acumulado_tasa_no_contacto}%</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Últimos 7 días */}
            <div className="row" style={{ paddingTop: 30 }}>
              <h1 style={{ textAlign: 'center', fontSize: 30 }}>Últimos 7 dí­as</h1>
              <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_logro}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_respuesta}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_cooperacion}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_rechazo}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_contacto}%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-2" style={{ paddingRight: 50 }}>
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                    {isloading ? (
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                    ) : (
                      <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTotal?.ultimo_7_dias_tasa_no_contacto}%</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Tabla */}
            <div className="table-responsive" style={{ width: "90%", margin: "30px auto" }}>
              <table className="table custom-table table-hover table-striped ">
                <thead className="titles">
                  <tr >
                    <th scope="col" width="40%">Instituciones</th>
                    <th scope="col" width="10%">Tasa Logro</th>
                    <th scope="col" width="10%">Tasa Respuesta</th>
                    <th scope="col" width="10%">Tasa Cooperación</th>
                    <th scope="col" width="10%">Tasa Rechazo</th>
                    <th scope="col" width="10%">Tasa Contacto</th>
                    <th scope="col" width="10%">Tasa no Contacto</th>
                    <th scope="col" width="10%">Registros con Datos</th>
                    <th scope="col" width="10%">Registros Contactados</th>
                    <th scope="col" width="10%">Registros Contactados / Registros disponibles</th>
                  </tr>
                </thead>
                <tbody>
                  {isloadingtabla ? (
                      <tr>
                        <td className="text-center" colSpan="10">
                        <div className="d-flex justify-content-center">
                        <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                        </div>
                        </div>
                        </td>
                      
                      </tr>
                    ): dataTableTotal.map((item) => {
                      return (
                        <tr>
                          <td className="td-nombre">
                            {item.nombre_institucion}
                          </td>
                          <td>{item.tasa_logro}%</td>
                          <td>{item.tasa_respuesta}%</td>
                          <td>{item.tasa_cooperacion}%</td>
                          <td>{item.tasa_rechazo}%</td>
                          <td>{item.tasa_contacto}%</td>
                          <td>{item.tasa_no_contacto}%</td>
                          <td>{item.registros_con_datos}</td>
                          <td>{item.registros_contactados}</td>
                          <td>{item.registros_contactados_disponibles}%</td></tr>
                      )
                  })}
                </tbody>
              </table>
              {/* BotÃ³n de descarga */}
              {/* <div style={{ textAlign: "right" }}>
                <button className="btn btn-primary" onClick={() => downloadExcelIndicadoresCampo()}>
                  Descargar Excel
                </button>
              </div> */}
            </div>
        </TabPane>

        <TabPane label="Telefónico">
          {/* Acumulado */}
          <div className="row" style={{ paddingTop: 20 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Acumulado</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.acumulado_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Últimos 7 días */}
          <div className="row" style={{ paddingTop: 30 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Últimos 7 días</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeTelefonico?.ultimo_7_dias_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Tabla */}
          <div className="table-responsive" style={{ width: "90%", margin: "30px auto" }}>
            <table className="table custom-table table-hover table-striped ">
              <thead className="titles">
                <tr >
                  <th scope="col" width="40%">Instituciones</th>
                  <th scope="col" width="10%">Tasa Logro</th>
                  <th scope="col" width="10%">Tasa Respuesta</th>
                  <th scope="col" width="10%">Tasa Cooperación</th>
                  <th scope="col" width="10%">Tasa Rechazo</th>
                  <th scope="col" width="10%">Tasa Contacto</th>
                  <th scope="col" width="10%">Tasa no Contacto</th>
                  <th scope="col" width="10%">Registros con Datos</th>
                  <th scope="col" width="10%">Registros Contactados</th>
                  <th scope="col" width="10%">Registros Contactados / Registros disponibles</th>
                </tr>
              </thead>
              <tbody>
                {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="10">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ): dataTableTelefonico.map((item) => {
                    return (
                      <tr>
                        <td className="td-nombre">
                          {item.nombre_institucion}
                        </td>
                        <td>{item.tasa_logro}%</td>
                        <td>{item.tasa_respuesta}%</td>
                        <td>{item.tasa_cooperacion}%</td>
                        <td>{item.tasa_rechazo}%</td>
                        <td>{item.tasa_contacto}%</td>
                        <td>{item.tasa_no_contacto}%</td>
                        <td>{item.registros_con_datos}</td>
                        <td>{item.registros_contactados}</td>
                        <td>{item.registros_contactados_disponibles}%</td></tr>
                    )
                })}
              </tbody>
            </table>
            {/* BotÃ³n de descarga */}
            {/* <div style={{ textAlign: "right" }}>
              <button className="btn btn-primary" onClick={() => downloadExcelIndicadoresCampo()}>
                Descargar Excel
              </button>
            </div> */}
          </div>
        </TabPane>

        <TabPane label="Digital">
          {/* Acumulado */}
          <div className="row" style={{ paddingTop: 20 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Acumulado</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.acumulado_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Últimos 7 días */}
          <div className="row" style={{ paddingTop: 30 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Últimos 7 días</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomeDigital?.ultimo_7_dias_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Tabla */}
          <div className="table-responsive" style={{ width: "90%", margin: "30px auto" }}>
            <table className="table custom-table table-hover table-striped ">
              <thead className="titles">
                <tr >
                  <th scope="col" width="40%">Instituciones</th>
                  <th scope="col" width="10%">Tasa Logro</th>
                  <th scope="col" width="10%">Tasa Respuesta</th>
                  <th scope="col" width="10%">Tasa Cooperación</th>
                  <th scope="col" width="10%">Tasa Rechazo</th>
                  <th scope="col" width="10%">Tasa Contacto</th>
                  <th scope="col" width="10%">Tasa no Contacto</th>
                  <th scope="col" width="10%">Registros con Datos</th>
                  <th scope="col" width="10%">Registros Contactados</th>
                  <th scope="col" width="10%">Registros Contactados / Registros disponibles</th>
                </tr>
              </thead>
              <tbody>
                {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="10">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ): dataTableDigital.map((item) => {
                    return (
                      <tr>
                        <td className="td-nombre">
                          {item.nombre_institucion}
                        </td>
                        <td>{item.tasa_logro}%</td>
                        <td>{item.tasa_respuesta}%</td>
                        <td>{item.tasa_cooperacion}%</td>
                        <td>{item.tasa_rechazo}%</td>
                        <td>{item.tasa_contacto}%</td>
                        <td>{item.tasa_no_contacto}%</td>
                        <td>{item.registros_con_datos}</td>
                        <td>{item.registros_contactados}</td>
                        <td>{item.registros_contactados_disponibles}%</td></tr>
                    )
                })}
              </tbody>
            </table>
            {/* BotÃ³n de descarga */}
            {/* <div style={{ textAlign: "right" }}>
              <button className="btn btn-primary" onClick={() => downloadExcelIndicadoresCampo()}>
                Descargar Excel
              </button>
            </div> */}
          </div>
        </TabPane>
        
        <TabPane label="Presencial">
          {/* Acumulado */}
          <div className="row" style={{ paddingTop: 20 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Acumulado</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.acumulado_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          
          {/* Últimos 7 días */}
          <div className="row" style={{ paddingTop: 30 }}>
            <h1 style={{ textAlign: 'center', fontSize: 30 }}>Últimos 7 días</h1>
            <div className="col-sm-2 mb-3 mb-sm-0" style={{ paddingLeft: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Logro</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_logro}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Respuesta</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_respuesta}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Cooperación</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_cooperacion}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Rechazo</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_rechazo}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa<br/>Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingRight: 50 }}>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title" style={{ textAlign: 'center', fontSize: 30 }}>Tasa no Contacto</h5>
                  {isloading ? (
                    <div className="d-flex justify-content-center">
                    <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                    </div>
                    </div>
                  ) : (
                    <p className="card-text" style={{ textAlign: 'center', fontSize: 30 }}>{cardsHomePresencial?.ultimo_7_dias_tasa_no_contacto}%</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Tabla */}
          <div className="table-responsive" style={{ width: "90%", margin: "30px auto" }}>
            <table className="table custom-table table-hover table-striped ">
              <thead className="titles">
                <tr >
                  <th scope="col" width="40%">Instituciones</th>
                  <th scope="col" width="10%">Tasa Logro</th>
                  <th scope="col" width="10%">Tasa Respuesta</th>
                  <th scope="col" width="10%">Tasa Cooperación</th>
                  <th scope="col" width="10%">Tasa Rechazo</th>
                  <th scope="col" width="10%">Tasa Contacto</th>
                  <th scope="col" width="10%">Tasa no Contacto</th>
                  <th scope="col" width="10%">Registros con Datos</th>
                  <th scope="col" width="10%">Registros Contactados</th>
                  <th scope="col" width="10%">Registros Contactados / Registros disponibles</th>
                </tr>
              </thead>
              <tbody>
                {isloadingtabla ? (
                    <tr>
                      <td className="text-center" colSpan="10">
                      <div className="d-flex justify-content-center">
                      <div className="spinner-border" style={{color:"#0557aa"}} role="status">
                      </div>
                      </div>
                      </td>
                    
                    </tr>
                  ): dataTablePresencial.map((item) => {
                    return (
                      <tr>
                        <td className="td-nombre">{item.nombre_institucion}</td>
                        <td>{item.tasa_logro}%</td>
                        <td>{item.tasa_respuesta}%</td>
                        <td>{item.tasa_cooperacion}%</td>
                        <td>{item.tasa_rechazo}%</td>
                        <td>{item.tasa_contacto}%</td>
                        <td>{item.tasa_no_contacto}%</td>
                        <td>{item.registros_con_datos}</td>
                        <td>{item.registros_contactados}</td>
                        <td>{item.registros_contactados_disponibles}%</td></tr>
                    )
                })}
              </tbody>
            </table>
            {/* BotÃ³n de descarga */}
            {/* <div style={{ textAlign: "right" }}>
              <button className="btn btn-primary" onClick={() => downloadExcelIndicadoresCampo()}>
                Descargar Excel
              </button>
            </div> */}
          </div>
        </TabPane>
      </Tabs>



    </div>
  );
};

export default Indicadores;
